import { styled } from '@mui/material';

interface Props {
  progress: number;
  color: string;
  height?: string;
}

const ProgressWrapper = styled('div')<{ height: string }>`
  height: ${({ height }) => height};
  background-color: ${({ theme }) => theme.colors.textAccent.disabled};
  width: 100%;
  border-radius: 0px 0px 4px 4px;
`;
const ProgressLine = styled('div')<{ progress: number; color: string; height: string }>`
  height: ${({ height }) => height};
  background-color: ${({ color }) => color};
  width: ${({ progress }) => `${progress}%`};
  transition: width 500ms ease-out;
  border-radius: 0px 0px 0px 4px;
`;

export const ProgressBar = ({ progress, color, height = '4px' }: Props) => {
  return (
    <ProgressWrapper height={height}>
      <ProgressLine progress={progress} color={color} height={height} />
    </ProgressWrapper>
  );
};
